module.exports = __webpack_public_path__ + "assets/img/bg.0282b1e4.png";